<template>
  <img :src="brand.logo.src" :width="brand.logo.width" height="56px" :alt="brand.productName + ' Logo'" />
</template>

<script>
import { getClientBrand } from "@/branding/brandingService";

export default {
  props: {
    source: {
      type: String,
      required: false
    }
  },
  computed: {
    brand() {
      return getClientBrand(this.source || this.$store.state.userType);
    }
  },

}
</script>
